import { render, staticRenderFns } from "./TextAndContentDetails.vue?vue&type=template&id=5a51a293&scoped=true"
import script from "./TextAndContentDetails.vue?vue&type=script&lang=js"
export * from "./TextAndContentDetails.vue?vue&type=script&lang=js"
import style0 from "./TextAndContentDetails.vue?vue&type=style&index=0&id=5a51a293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51a293",
  null
  
)

export default component.exports